/*
 * The plugin class.
 */
import Dinero from 'dinero.js';

const Money = {
    install(app, options) {
        app.config.globalProperties.$numberParser = {
            toCurrency: (value, currencyCode, locale) => {
                return Dinero({ amount: value }).toUnit().toLocaleString(locale, { style: 'currency', currency: currencyCode });
            },
        };
    },
};

export default Money;
